<template>
    <div>
        <div class="flex justify-end">
            <vs-button class="float-right" color="primary" icon-pack="feather" icon="icon-plus" @click="btnAddUser">
                {{ $t('tasks.addUser') }}
            </vs-button>
        </div>
        <div class="vx-card p-6 mt-6">
            <vs-table id="title-item" stripe search :pagination="projectUserData.length > 0" maxItems="20"
                      noDataText="Không có dữ liệu" :data="projectUserData">
                <template slot="thead">
                    <vs-th>STT</vs-th>
                    <vs-th>{{ $t('tasks.codeEmployee') }}</vs-th>
                    <vs-th>{{ $t('tasks.userName') }}</vs-th>
                    <vs-th>{{ $t('tasks.image') }}</vs-th>
<!--                    <vs-th> {{ $t('tasks.phoneNumber') }}</vs-th>-->
                    <vs-th> {{ $t('tasks.createdDate') }}</vs-th>
                    <vs-th>{{ $t('tasks.action') }}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr v-for="(colum, ind) in data" :key="ind">
                        <vs-td>
                            <div>{{ colum.stt }}</div>
                        </vs-td>
                        <vs-td>
                            <div>{{ colum.employeeCode }}</div>
                        </vs-td>
                        <vs-td>
                            <div>{{ colum.fullName }}</div>
                        </vs-td>
                        <vs-td>
                            <div v-if="colum.avatar"><img :src="colum.avatar" alt=""
                                                          class="w-12 h-12 rounded-full mr-3">
                            </div>
                            <div v-else><img
                                src="@/assets/images/portrait/small/user-avatar.png"
                                alt="" class="w-12 h-12 rounded-full mr-3"></div>
                        </vs-td>
<!--                        <vs-td>-->
<!--                            <div>{{ colum.phoneNumber }}</div>-->
<!--                        </vs-td>-->
                        <vs-td>
                            <div>{{ colum.createdDateStr }}</div>
                        </vs-td>
                        <vs-td>
                            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                                <feather-icon icon="TrashIcon" class="text-danger"
                                              svgClasses="h-5 w-5"
                                              @click="deleteUser(colum.id, colum.index)"/>
                            </vx-tooltip>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <vs-popup :title="$t('tasks.addUser')" :active.sync="popupUser">
                <div class="vx-col md:w-full" style="max-height:100px!important">
                    <label class="vs-input--label required">{{ $t('tasks.selectEmployee') }}</label><br/>
                    <multiselect data-vv-validate-on="input" v-model="selecUser" :options="employeeOptions"
                                 group-values="libs"
                                 group-label="all"
                                 :group-select="true"
                                 :show-labels="false"
                                 :multiple="true"
                                 :close-on-select="false"
                                 placeholder=""
                                 label="label"
                                 track-by="value"
                                 name="member"
                                 @input="changeSelectMultiple">
                        <template #noResult>
                            <span>Không có dữ liệu phù hợp!</span>
                        </template>
                        <template #noOptions>
                            <span>Không có dữ liệu!</span>
                        </template>
                    </multiselect>
                    <span class="text-danger text-sm">{{ errors.first('member') }}</span>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full" style="margin-top: 170px">
                        <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                            <vs-button class="mr-5" @click="addUser">{{ $t('tasks.add') }}</vs-button>
                            <vs-button class="" color="danger" type="border" @click="popupUser = false">{{
                                    $t('tasks.close')
                                }}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>
        </div>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import {AgGridVue} from "ag-grid-vue";
import Multiselect from 'vue-multiselect';
import moment from "moment";

export default {
    components: {
        AgGridVue,
        Multiselect
    },
    data() {
        return {
            popupUser: false,
            employeeOptions: [
                {
                    all: 'Tất cả',
                    libs: []
                }
            ],
            userData: {
                employeeIds: [],
            },
            projectUserData: [],
            selecUser: [],
            proejectId: null,
        }
    },
    created() {

        this.proejectId = parseInt(this.$route.query.id, 10);
        let branchList = JSON.parse(localStorage.getItem("branchInfoList") || "[]");
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t("warningMenuOrganization.emptyEmployee"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
            });
        }
        this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map((item) => {
            return {value: item.id, label: item.organizationBranchName};
        });
        this.organizationBranchOptions.unshift({
            value: null,
            label: this.$t("menuOrganization.all"),
        });
        this.getEmployeeAdd();
    },
    methods: {
        async btnAddUser() {
            await this.getEmployee()
            this.selecUser = null
            this.$validator.reset()
            this.popupUser = true
        },
        getEmployeeAdd() {
            this.$vs.loading()
            this.$crm.get(`/project/get-project-employees/${this.proejectId}`).then((response) => {
                if (response.data && response.data.length > 0) {
                    this.projectUserData = response.data.map(el => {
                        el.stt = response.data.indexOf(el) + 1
                        el.createdDateStr = moment(el.createdDate).format('DD/MM/YYYY HH:mm')
                        return el
                    })
                }
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: "Lỗi",
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
            });
        },
        getEmployee() {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                let payload = {
                    permissions: ['PRIVILEGE_TASK_MODERATOR'],
                    organizationId: userInfo.organization.id
                }
                this.$vs.loading()
                this.$crm.post(`/employee/get-employees-by-permissions`, payload).then((response) => {
                    if (response.data && response.data.length > 0) {
                        let arr = []
                        response.data.forEach(el => {
                            let employee = this.projectUserData.find(x => x.employeeId === el.employeeId)
                            if (!employee) arr.push(el)
                        })
                        this.employeeOptions[0].libs = arr.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName,
                            }
                        })
                    }
                    resolve(response)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: "Lỗi",
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                });
            })
        },
        async addUser(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;
            this.$vs.loading();
            this.$crm.post(`/project/add-employees-to-project/${this.proejectId}`, this.userData.employeeIds).then((response) => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: "success",
                    text: `Thêm mới thành công`,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
                this.popupUser = false;
                this.getEmployeeAdd();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: "Lỗi",
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
            });
        },
        changeSelectMultiple() {
            this.userData.employeeIds = [];
            this.selecUser.forEach(el => {
                this.userData.employeeIds.push(el.value);
            })
        },
        deleteUser(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa nhân sự này không ?`,
                accept: () => this.acceptDeleteUser(id),
                acceptText: "Xóa",
                cancelText: "Huỷ"

            })
        },
        acceptDeleteUser(id) {

            this.$vs.loading();
            this.$crm
                .delete(`/project/remove-employee-from-project/${this.proejectId}?employeeId=${id}`)
                .then((response) => {
                    this.getEmployeeAdd();

                    this.$vs.loading.close();

                });
        },
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
    }

}
</script>
<style lang="scss">
.multiselect .multiselect__content-wrapper {
    max-height: 155px !important;
}

.required::after {
    content: '* ';
    color: red;
}
</style>
